import { Layout } from "antd";
import { useEffect, useState } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { paths } from "../constants";
import { Header, MainSider } from "../layouts/main";
import { NotFound } from "../pages/common";
import { ScrollToTop } from "../hooks";
import { AboutUs, ContactUs, HomePage, ProductList, Recruitment, Site, Project, Introduction, Product, NewsDetail } from "../pages/main";
import Footer from "../layouts/common/Footer/Footer";
import { SmallUp } from "../assets/svg";
import '../assets/style/mixins.less'

const MainRoute = (props) => {
  const [collapsed, setCollapsed] = useState(true);

  const [scrollHeight, setHeight] = useState(0)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    // return 
    //   window.removeEventListener('scroll', handleScroll)
  },
    [])


  const handleScroll = (event) => {
    setHeight(window.scrollY)
  }

  return (
    <>
      <ScrollToTop />
      <Layout>
        <MainSider collapsed={collapsed}  onPressCollapse={() => setCollapsed(true)}/>
        <Layout>
          <Header
            collapsedSider={collapsed}
            onPressCollapse={() => setCollapsed((val) => !val)}
          />
          <Layout style={{ background: '#fff' }}>
            <Layout.Content className={'body-container'}>
              <Switch>
                <Route
                  exact
                  path={paths.home_page_route}
                  component={HomePage}
                />
                <Route
                  exact
                  path={paths.about_us}
                  component={AboutUs}
                />
                <Route
                  exact
                  path={paths.product}
                  component={Product}
                />
                <Route
                  exact
                  path={paths.product_list}
                  component={ProductList}
                />
                <Route
                  exact
                  path={paths.recruitment}
                  component={Recruitment}
                />
                <Route
                  exact
                  path={paths.contact_us}
                  component={ContactUs}
                />
                <Route
                  exact
                  path={paths.site}
                  component={Site}
                />
                <Route
                  exact
                  path={paths.projects}
                  component={Project}
                />
                <Route
                  exact
                  path={paths.introduction}
                  component={Introduction}
                />
                <Route
                  exact
                  path={paths.news_detail}
                  component={NewsDetail}
                />
                <Route
                  exact
                  path={paths.news_detail_wId}
                  component={NewsDetail}
                />

                <Redirect exact from={paths.main_tag} to={paths.home_page} />
                <Route component={NotFound} />
              </Switch>
            </Layout.Content>
            <Footer/>
              
          </Layout>
        </Layout>
      </Layout>
      {scrollHeight > 500 && <div onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // for smoothly scrolling
        });
      }}
        className='scrollToTop' >
        <div className='svg-container' style={{ width: '88%', height: '88%' }}>
          <SmallUp className='svg' />
        </div>
      </div>}
    </>
  );
};

export default withRouter(MainRoute);
